import Label from "components/general/Label"
import { filterArray, findArray } from 'helpers/utils'
import { ResultRankDiff } from "components/presentation/ResultRank"
import { getRscObject } from "helpers/rsc"


/**
 * Return String RSC Event composed DISCIPLINE+SEX+EVENT
 * 
 * Example: ATHM200M--------------
 *
 * @_rsc : RSC Code  to extract long Event 
 */


export function isLess4Intermediates(rsc) {
    return (rsc.match("SWM[MW]50M.+") || rsc.match("SWM[MW]100M.+") || rsc.match("SWM[MW]200M.+"));
}

export function getIsEventRelay(rsc) {
    return (rsc.match("SWM[MWX]4X.+"));
}

export function getIsRelay100M(rsc) {
    return (rsc.match("SWM[MWX]4X1+"));
}

export function getIsRelay200M(rsc) {
    return (rsc.match("SWM[MWX]4X2+"));
}

export function hasConfig(config) {
    let sw = config.filter(rowConf => rowConf.code === 'INTERMEDIATE').length > 0
    return (
        sw
    )
}

export const isPhaseFinal = (rsc) => {
    const { event, phase } = getRscObject(rsc);
    return phase.includes("FNL-");
}


export function createColumnsIntermediate(columnsAdded, isLess4) {
    let numCols = findArray(columnsAdded, { code: ['INTERMEDIATES_NUM'], type: ['EC'] }).value
    let config = filterArray(columnsAdded, { code: ['INTERMEDIATE'] })
    config = config.filter((item) => item.pos !== 'S');
    let columnsExt = []
    let less4Int = false

    config.map((item) => {
        let split = item.pos === 'F' ? numCols : item.pos;
        let header = item.pos === 'F' ? <Label data="HeaderFinish" /> : item.value + 'm';


        let column = {
            Header: header,
            accessor: (props) => (
                props?.extendedResults
                    ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [item.pos] }).er_sortorder
                    : ''
            ),

            Cell: (props) => (
                getCell(props.cell.row.original, item.pos)
            ),
            //isVisible: false,
            disableSortBy: true,
            //columnIndex: split,
            id: 'Splits-' + split,
            className: 'result',
            headerClassName: 'text-end w-10',
            sortType: "absoluteOrderNumber"
        }
        let colExt = { ...column, columnIndex: split, isVisible: false }
        columnsExt.push(isLess4 ? column : colExt)
    })

    return columnsExt
}

function getCell(row, split) {

    let cell = null

    if (!!row) {

        let intermediate = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [split] })
        cell = <ResultRankDiff result={intermediate?.er_value} rank={intermediate.er_rank} />

    }
    return cell



}
